import React from "react";
import { motion } from "framer-motion";
import { Row, Col } from "react-bootstrap";
function BrandSection({ text, brandImg, brandName }) {
  return (
    <Row className="froi_brand_section">
      <Col lg={6} xs={12}>
        <div className="froi_brand_text">
          <p className="froi_text">{text}</p>
        </div>
      </Col>
      <Col lg={6} xs={12}>
        <motion.div
          className="froi_brand_img"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ amount: 0.5 }}
          transition={{
            duration: 0.9,
            ease: "easeInOut",
            delay: 0.8,
          }}
        >
          <img src={brandImg} alt={brandName} />
        </motion.div>
      </Col>
    </Row>
  );
}

export default BrandSection;
